import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from '../components/Header'
import Footer from '../components/Footer'
import "./index.less"

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="安信通 ｜ 只做最好的服務機器人"
      meta={[
        { name: 'description', content: '安信通只做最好的服務機器人' },
        { name: 'keywords', content: '安信通,服務機器人' },
      ]}
    />
    <Header />    
    {children}
    <Footer />
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper
